import { css } from '@emotion/core';
import MediaQueries from '../../../../styles/Grid/MediaQueries';
import { colorsPalette } from '../../../../styles/colors';

export const containerCtaCss = css({
  margin: '64px 0',
  [MediaQueries.smAndUp]: {
    width: '100%',
  },
  [MediaQueries.mdAndUp]: {
    margin: 0,
  },
});

export const secondaryButtonCss = css({
  marginTop: 24,
  [MediaQueries.lgAndUp]: {
    marginTop: 18,
  },
});

export const dividerCss = css({
  margin: '40px 0',
  borderBottom: `1px solid ${colorsPalette.grey10}`,
  width: '100%',
});
